import "./Gallery.css";

function Gallery() {
  return <section className="gallery-section">Gallery</section>;
}

export default Gallery;
